import { InfoMessage } from '@avantstay/backoffice-core'

import { mountRouteUrl, ROUTES } from '@routes'

import * as S from './SourceGapNotice.styles'

interface SourceGapNoticeProps {
  bookingCode: string
  channelLabel?: string
  clipped?: { shown: number; total: number }
  hasGap: boolean
}

export const SourceGapNotice = ({
  bookingCode,
  channelLabel,
  clipped,
  hasGap,
}: SourceGapNoticeProps) => {
  if (!hasGap && !clipped) return null

  const threadLink = (
    <S.ThreadLink
      href={mountRouteUrl(ROUTES.bookingSMSConversations.path, { hash: bookingCode })}
      target="_blank"
      rel="noopener"
    >
      Full thread ↗
    </S.ThreadLink>
  )

  if (hasGap) {
    return (
      <InfoMessage
        messageType="warning"
        showIcon
        margin="0 0 16px"
        message={
          <>
            {`Nothing the guest said is in our sources for this stay — no inbound message, ticket or call. Their side is likely in the ${channelLabel ?? 'booking channel'} inbox, which this board does not ingest. `}
            {threadLink}
          </>
        }
      />
    )
  }

  if (clipped) {
    return (
      <InfoMessage
        messageType="accent"
        showIcon
        margin="0 0 16px"
        message={
          <>
            {`Showing the last ${clipped.shown} of ${clipped.total} Spoke messages. `}
            {threadLink}
          </>
        }
      />
    )
  }

  return null
}
